/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsPersonalizationDownloads
 */
export interface MelcoFusionModelsPersonalizationDownloads {
    /**
     * 
     * @type {Array<string>}
     * @memberof MelcoFusionModelsPersonalizationDownloads
     */
    personalization_list?: Array<string> | null;
}

export function MelcoFusionModelsPersonalizationDownloadsFromJSON(json: any): MelcoFusionModelsPersonalizationDownloads {
    return MelcoFusionModelsPersonalizationDownloadsFromJSONTyped(json, false);
}

export function MelcoFusionModelsPersonalizationDownloadsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsPersonalizationDownloads {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personalization_list': !exists(json, 'personalization_list') ? undefined : json['personalization_list'],
    };
}

export function MelcoFusionModelsPersonalizationDownloadsToJSON(value?: MelcoFusionModelsPersonalizationDownloads | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personalization_list': value.personalization_list,
    };
}


